import React from 'react';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 px-4 border-b border-brown/20 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-81">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-82">
        <div className="flex items-center gap-2 text-forest mb-1" data-id="element-83">
          <BookOpen size={24} data-id="element-84" />
          <h1 className="font-handwriting text-3xl font-bold tracking-wide" data-id="element-85">
            Napftagebuch
          </h1>
        </div>
        <p className="font-serif text-sm text-brown italic" data-id="element-86">
          Ehrliche Geschichten aus dem Hundealltag
        </p>
      </div>
    </header>;
}